import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Divider as AntDivider } from 'antd';

import './styles.less';

export const Divider = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'divider',
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <AntDivider className={ classes } />
    );
};

Divider.defaultProps = {
    // ...
};

Divider.propTypes = {
    className: PropTypes.string,
};
